import { Card } from "../ui/card.js";
import { SelectInput, TextInput } from "../ui/field.js";
import { DOCUMENT_OWNER_OPTIONS } from "../../lib/ownerOptions.js";
import { useI18n, type MessageKey } from "../../i18n/index.js";

const OWNER_TYPE_LABEL_KEYS: Record<string, MessageKey> = {
  other: "documents.ownerType.other",
  customer: "documents.ownerType.customer",
  quote: "documents.ownerType.quote",
  job: "documents.ownerType.job",
  purchase_order: "documents.ownerType.purchase_order",
  invoice: "documents.ownerType.invoice",
};

export function OwnerFilter({
  ownerType,
  ownerId,
  onOwnerTypeChange,
  onOwnerIdChange,
}: {
  ownerType: string;
  ownerId: string;
  onOwnerTypeChange(value: string): void;
  onOwnerIdChange(value: string): void;
}) {
  const { t } = useI18n();
  const options = DOCUMENT_OWNER_OPTIONS.map((option) => ({
    value: option.value,
    label: t(OWNER_TYPE_LABEL_KEYS[option.value] as MessageKey),
  }));

  return (
    <Card className="mb-5">
      <div className="grid gap-3 sm:grid-cols-2">
        <SelectInput
          label={t("documents.filter.attachedTo")}
          options={options}
          value={ownerType}
          onChange={(e) => onOwnerTypeChange(e.target.value)}
        />
        <TextInput
          label={t("documents.filter.reference")}
          value={ownerId}
          onChange={(e) => onOwnerIdChange(e.target.value)}
          hint={t("documents.filter.referenceHint")}
        />
      </div>
    </Card>
  );
}
